/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    MutationFunction,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query'

import type {
    DeleteRequestJobsFilesByIdReactionByJobUuidAndFileUuidParams,
    GetRequestJobsReactionsByJobUuidParams,
    HTTPValidationErrorDTO,
    PostRequestJobsFilesByIdReactionByJobUuidAndFileUuidParams,
    ReactionsResponseDTO,
    SetReactionResponseDTO,
} from '../../model'

import { customInstance } from '../../../customInstance'
import type { ErrorType } from '../../../customInstance'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * adds a reaction

 * @summary Post Reaction
 */
export const postRequestJobsFilesByIdReactionByJobUuidAndFileUuid = (
    jobUuid: string,
    fileUuid: string,
    params: PostRequestJobsFilesByIdReactionByJobUuidAndFileUuidParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<SetReactionResponseDTO>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/files_by_id/${encodeURIComponent(String(fileUuid))}/reaction`,
            method: 'POST',
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestJobsFilesByIdReactionByJobUuidAndFileUuidMutationOptions =
    <
        TError = ErrorType<void | HTTPValidationErrorDTO>,
        TContext = unknown,
    >(options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    typeof postRequestJobsFilesByIdReactionByJobUuidAndFileUuid
                >
            >,
            TError,
            {
                jobUuid: string
                fileUuid: string
                params: PostRequestJobsFilesByIdReactionByJobUuidAndFileUuidParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    }): UseMutationOptions<
        Awaited<
            ReturnType<
                typeof postRequestJobsFilesByIdReactionByJobUuidAndFileUuid
            >
        >,
        TError,
        {
            jobUuid: string
            fileUuid: string
            params: PostRequestJobsFilesByIdReactionByJobUuidAndFileUuidParams
        },
        TContext
    > => {
        const mutationKey = [
            'postRequestJobsFilesByIdReactionByJobUuidAndFileUuid',
        ]
        const { mutation: mutationOptions, request: requestOptions } = options
            ? options.mutation &&
              'mutationKey' in options.mutation &&
              options.mutation.mutationKey
                ? options
                : { ...options, mutation: { ...options.mutation, mutationKey } }
            : { mutation: { mutationKey }, request: undefined }

        const mutationFn: MutationFunction<
            Awaited<
                ReturnType<
                    typeof postRequestJobsFilesByIdReactionByJobUuidAndFileUuid
                >
            >,
            {
                jobUuid: string
                fileUuid: string
                params: PostRequestJobsFilesByIdReactionByJobUuidAndFileUuidParams
            }
        > = (props) => {
            const { jobUuid, fileUuid, params } = props ?? {}

            return postRequestJobsFilesByIdReactionByJobUuidAndFileUuid(
                jobUuid,
                fileUuid,
                params,
                requestOptions,
            )
        }

        return { mutationFn, ...mutationOptions }
    }

export type PostRequestJobsFilesByIdReactionByJobUuidAndFileUuidMutationResult =
    NonNullable<
        Awaited<
            ReturnType<
                typeof postRequestJobsFilesByIdReactionByJobUuidAndFileUuid
            >
        >
    >

export type PostRequestJobsFilesByIdReactionByJobUuidAndFileUuidMutationError =
    ErrorType<void | HTTPValidationErrorDTO>

/**
 * @summary Post Reaction
 */
export const usePostRequestJobsFilesByIdReactionByJobUuidAndFileUuid = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    typeof postRequestJobsFilesByIdReactionByJobUuidAndFileUuid
                >
            >,
            TError,
            {
                jobUuid: string
                fileUuid: string
                params: PostRequestJobsFilesByIdReactionByJobUuidAndFileUuidParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<
        ReturnType<typeof postRequestJobsFilesByIdReactionByJobUuidAndFileUuid>
    >,
    TError,
    {
        jobUuid: string
        fileUuid: string
        params: PostRequestJobsFilesByIdReactionByJobUuidAndFileUuidParams
    },
    TContext
> => {
    const mutationOptions =
        getPostRequestJobsFilesByIdReactionByJobUuidAndFileUuidMutationOptions(
            options,
        )

    return useMutation(mutationOptions, queryClient)
}
/**
 * removes a reaction

 * @summary Delete Reaction
 */
export const deleteRequestJobsFilesByIdReactionByJobUuidAndFileUuid = (
    jobUuid: string,
    fileUuid: string,
    params: DeleteRequestJobsFilesByIdReactionByJobUuidAndFileUuidParams,
    options?: SecondParameter<typeof customInstance>,
) => {
    return customInstance<SetReactionResponseDTO>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/files_by_id/${encodeURIComponent(String(fileUuid))}/reaction`,
            method: 'DELETE',
            params,
        },
        options,
    )
}

export const getDeleteRequestJobsFilesByIdReactionByJobUuidAndFileUuidMutationOptions =
    <
        TError = ErrorType<void | HTTPValidationErrorDTO>,
        TContext = unknown,
    >(options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    typeof deleteRequestJobsFilesByIdReactionByJobUuidAndFileUuid
                >
            >,
            TError,
            {
                jobUuid: string
                fileUuid: string
                params: DeleteRequestJobsFilesByIdReactionByJobUuidAndFileUuidParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    }): UseMutationOptions<
        Awaited<
            ReturnType<
                typeof deleteRequestJobsFilesByIdReactionByJobUuidAndFileUuid
            >
        >,
        TError,
        {
            jobUuid: string
            fileUuid: string
            params: DeleteRequestJobsFilesByIdReactionByJobUuidAndFileUuidParams
        },
        TContext
    > => {
        const mutationKey = [
            'deleteRequestJobsFilesByIdReactionByJobUuidAndFileUuid',
        ]
        const { mutation: mutationOptions, request: requestOptions } = options
            ? options.mutation &&
              'mutationKey' in options.mutation &&
              options.mutation.mutationKey
                ? options
                : { ...options, mutation: { ...options.mutation, mutationKey } }
            : { mutation: { mutationKey }, request: undefined }

        const mutationFn: MutationFunction<
            Awaited<
                ReturnType<
                    typeof deleteRequestJobsFilesByIdReactionByJobUuidAndFileUuid
                >
            >,
            {
                jobUuid: string
                fileUuid: string
                params: DeleteRequestJobsFilesByIdReactionByJobUuidAndFileUuidParams
            }
        > = (props) => {
            const { jobUuid, fileUuid, params } = props ?? {}

            return deleteRequestJobsFilesByIdReactionByJobUuidAndFileUuid(
                jobUuid,
                fileUuid,
                params,
                requestOptions,
            )
        }

        return { mutationFn, ...mutationOptions }
    }

export type DeleteRequestJobsFilesByIdReactionByJobUuidAndFileUuidMutationResult =
    NonNullable<
        Awaited<
            ReturnType<
                typeof deleteRequestJobsFilesByIdReactionByJobUuidAndFileUuid
            >
        >
    >

export type DeleteRequestJobsFilesByIdReactionByJobUuidAndFileUuidMutationError =
    ErrorType<void | HTTPValidationErrorDTO>

/**
 * @summary Delete Reaction
 */
export const useDeleteRequestJobsFilesByIdReactionByJobUuidAndFileUuid = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    typeof deleteRequestJobsFilesByIdReactionByJobUuidAndFileUuid
                >
            >,
            TError,
            {
                jobUuid: string
                fileUuid: string
                params: DeleteRequestJobsFilesByIdReactionByJobUuidAndFileUuidParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<
        ReturnType<
            typeof deleteRequestJobsFilesByIdReactionByJobUuidAndFileUuid
        >
    >,
    TError,
    {
        jobUuid: string
        fileUuid: string
        params: DeleteRequestJobsFilesByIdReactionByJobUuidAndFileUuidParams
    },
    TContext
> => {
    const mutationOptions =
        getDeleteRequestJobsFilesByIdReactionByJobUuidAndFileUuidMutationOptions(
            options,
        )

    return useMutation(mutationOptions, queryClient)
}
/**
 * Get information for all active files that have a reaction connected to the file.
Only owner can query this information

 * @summary Get Reactions For Job
 */
export const getRequestJobsReactionsByJobUuid = (
    jobUuid: string,
    params: GetRequestJobsReactionsByJobUuidParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<ReactionsResponseDTO>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/reactions`,
            method: 'GET',
            params,
            signal,
        },
        options,
    )
}

export const getGetRequestJobsReactionsByJobUuidQueryKey = (
    jobUuid?: string,
    params?: GetRequestJobsReactionsByJobUuidParams,
) => {
    return [`/jobs/${jobUuid}/reactions`, ...(params ? [params] : [])] as const
}

export const getGetRequestJobsReactionsByJobUuidQueryOptions = <
    TData = Awaited<ReturnType<typeof getRequestJobsReactionsByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsReactionsByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsReactionsByJobUuid>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey =
        queryOptions?.queryKey ??
        getGetRequestJobsReactionsByJobUuidQueryKey(jobUuid, params)

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getRequestJobsReactionsByJobUuid>>
    > = ({ signal }) =>
        getRequestJobsReactionsByJobUuid(
            jobUuid,
            params,
            requestOptions,
            signal,
        )

    return {
        queryKey,
        queryFn,
        enabled: !!jobUuid,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestJobsReactionsByJobUuid>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestJobsReactionsByJobUuidQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestJobsReactionsByJobUuid>>
>
export type GetRequestJobsReactionsByJobUuidQueryError =
    ErrorType<void | HTTPValidationErrorDTO>

export function useGetRequestJobsReactionsByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsReactionsByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsReactionsByJobUuidParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsReactionsByJobUuid>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<typeof getRequestJobsReactionsByJobUuid>
                    >,
                    TError,
                    Awaited<ReturnType<typeof getRequestJobsReactionsByJobUuid>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestJobsReactionsByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsReactionsByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsReactionsByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsReactionsByJobUuid>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<typeof getRequestJobsReactionsByJobUuid>
                    >,
                    TError,
                    Awaited<ReturnType<typeof getRequestJobsReactionsByJobUuid>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestJobsReactionsByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsReactionsByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsReactionsByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsReactionsByJobUuid>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Get Reactions For Job
 */

export function useGetRequestJobsReactionsByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsReactionsByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsReactionsByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsReactionsByJobUuid>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
} {
    const queryOptions = getGetRequestJobsReactionsByJobUuidQueryOptions(
        jobUuid,
        params,
        options,
    )

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> }

    query.queryKey = queryOptions.queryKey

    return query
}
